export enum ApplicantSectionType {
  Editable = 1,
  ViewOnly = 2,
  Hidden = 3
}
